import React from 'react'
import PropTypes from 'prop-types'
import { withNotifier } from '@softwaredev_cegeka/stix-notifier'
import * as serviceWorkerRegistration from 'src/serviceWorkerRegistration'
import { checkForUpdate } from 'src/serviceWorkerRegistration'
import Loader from 'src/components/Loader'
import styles from './serviceWorkerUpdater.module.scss'

export default withNotifier(
    class ServiceWorkerUpdater extends React.Component {
        static propTypes = {
            pollInterval: PropTypes.number,
            notifier: PropTypes.shape({
                addSnackbarMessage: PropTypes.func,
            }),
            children: PropTypes.node,
        }
        static defaultProps = {
            pollInterval: 60000,
            children: '',
        }

        /**
         * @type {null|number} reference to the setInterval timer.
         */
        intervalRef = null

        /**
         * Register the interval timer which runs the sw update check.
         */
        componentDidMount() {
            this.intervalRef = setInterval(
                this.checkForServiceWorkerUpdate,
                this.props.pollInterval
            )
            this.checkForServiceWorkerUpdate()
        }

        /**
         * @return {Promise<void>}
         */
        checkForServiceWorkerUpdate = async () => {
            const updateAvailable = await checkForUpdate()

            if (updateAvailable) {
                const { notifier } = this.props
                const snackbarId = notifier.addSnackbarMessage(
                    `A new version of Horizon is available.`,
                    {
                        actionLabel: 'Reload',
                        handleAction: () => {
                            serviceWorkerRegistration.skipWaitingAndReload()
                            notifier.deleteSnackbarMessage(snackbarId)
                            notifier.addSnackbarMessage(
                                <>
                                    A new version of Horizon is available.
                                    <Loader className={styles.loader} />
                                </>,
                                {
                                    autoHide: false,
                                }
                            )
                        },
                        autoHide: false,
                    }
                )
            }
        }

        /**
         * Stop checking for updates.
         */
        componentWillUnmount() {
            clearInterval(this.intervalRef)
        }

        /**
         * @return {React.ReactNode}
         */
        render() {
            return this.props.children
        }
    }
)
